import React from "react";
import { Sparkles } from "lucide-react";
import { handlePrimaryCta, PRIMARY_CTA_LABEL } from "@/lib/contact";

export default function MobileCallBar() {
  return (
    <div
      data-testid="mobile-call-bar"
      className="lg:hidden fixed bottom-3 inset-x-3 z-40"
    >
      <a
        href="#contact"
        onClick={handlePrimaryCta}
        data-testid="mobile-call-bar-link"
        className="flex items-center justify-center gap-2 w-full rounded-full bg-brand text-white px-5 py-4 text-base font-semibold shadow-[0_18px_40px_-10px_rgba(91,91,255,0.7)] active:scale-[0.99]"
      >
        <Sparkles className="h-5 w-5" />
        {PRIMARY_CTA_LABEL}
      </a>
    </div>
  );
}
